export default {"src":"/_next/static/media/CirclePlusDark.33fcf318.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};